
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useRef, useState } from 'react'
import ReportHeader from '../component/report-header/ReportHeader';
import AHMIS, { API_URL } from '../../../api/api';
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import AddAlertMessage from '../../../components/alert/Alert';
import MessageBlock from '../../admin/components/message-block/MessageBlock';
import PatientCountCell from '../../../components/patient-count-cell/PatientCountCell';

const SalyaChikitsaReport = () => {

  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.shalyaChikitsaReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url).then(response => {
      const jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setTableData(jsondata.data);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
    });
  };
  return (
    <>
      <ReportHeader
        title="शल्य चिकित्सा सेवा प्रतिवेदन"
        getReportData={getReportData}
        printComponentRef={printComponentRef}
        reportData={Boolean(tableData)}
      />
      {tableData ? (
        <Box ref={printComponentRef}>
          <TableContainer classes={{ root: "fixed-head-table-container" }}>
            <Typography variant="body1" className="report-heading">शल्य चिकित्सा सेवा प्रतिवेदन</Typography>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="salyachikitsa-Sewa-Report">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell colSpan={2}> सेवाको विवरण</TableCell>
                  <TableCell>क्षारसूत्र</TableCell>
                  <TableCell>अग्निकर्म</TableCell>
                  <TableCell>रक्तमोक्षण</TableCell>
                  <TableCell>मर्म उपचार</TableCell>
                  <TableCell>विशिष्ठिकृत शल्य सेवा</TableCell>
                  <TableCell>अन्य शल्य सेवा</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell rowSpan={3}>नयाँ सेवाग्राहीको संख्या</TableCell>
                  <TableCell>महिला</TableCell>
                  <PatientCountCell data={tableData.NEW_PATIENT?.FEMALE?.["1"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.FEMALE?.["2"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.FEMALE?.["3"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.FEMALE?.["4"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.FEMALE?.["5"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.FEMALE?.["6"]} />
                </TableRow>
                <TableRow>
                  <TableCell>पुरुष</TableCell>
                  <PatientCountCell data={tableData.NEW_PATIENT?.MALE?.["1"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.MALE?.["2"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.MALE?.["3"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.MALE?.["4"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.MALE?.["5"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.MALE?.["6"]} />
                </TableRow>
                <TableRow>
                  <TableCell>अन्य</TableCell>
                  <PatientCountCell data={tableData.NEW_PATIENT?.OTHER?.["1"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.OTHER?.["2"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.OTHER?.["3"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.OTHER?.["4"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.OTHER?.["5"]} />
                  <PatientCountCell data={tableData.NEW_PATIENT?.OTHER?.["6"]} />
                </TableRow>
                <TableRow>
                  <TableCell rowSpan={3}>पुनरावृत्त सेवाग्राहीको संख्या </TableCell>
                  <TableCell>महिला</TableCell>
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.FEMALE?.["1"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.FEMALE?.["2"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.FEMALE?.["3"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.FEMALE?.["4"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.FEMALE?.["5"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.FEMALE?.["6"]} />
                </TableRow>
                <TableRow>
                  <TableCell>पुरुष</TableCell>
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.MALE?.["1"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.MALE?.["2"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.MALE?.["3"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.MALE?.["4"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.MALE?.["5"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.MALE?.["6"]} />
                </TableRow>
                <TableRow>
                  <TableCell>अन्य</TableCell>
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.OTHER?.["1"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.OTHER?.["2"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.OTHER?.["3"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.OTHER?.["4"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.OTHER?.["5"]} />
                  <PatientCountCell data={tableData.PREVIOUS_PATIENT?.OTHER?.["6"]} />
                </TableRow>
              </TableBody>
            </Table>

          </TableContainer>
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default SalyaChikitsaReport;
